<i18n>
{
  "en": {
    "title": "Order Info",
    "pleaseEntertaxId": "Please enter tax ID (8 digits)"
  },
  "zh-tw": {
    "title": "訂單資訊",
    "pleaseEntertaxId": "請輸入統一編號 (8碼)"
  }
}
</i18n>

<template>
  <prompt
    :title="$t(`title`)"
    :label="$t(`pleaseEntertaxId`)"
    :defaultValue="taxId"
    inputType="number"
    placeholder="ex. 13572468"
    :validator="validator"
    @confirm="v => setOrderParams({ taxId: v })" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Prompt from '@/common/components/Prompt'
import { validateTaxId } from '@/common/helpers/validators'

export default {
  computed: {
    ...mapState(['taxId']),
    validator () {
      return validateTaxId
    }
  },
  methods: {
    ...mapActions(['setOrderParams'])
  },
  components: { Prompt }
}
</script>
